<app-dialog-header [title]="title" class="tw-text-center"></app-dialog-header>

<div mat-dialog-content>
    <div class="tw-text-center tw-font-bold tw-mb-2">
        {{ "Reason for PTO - Time Range - PTO Description" }}
    </div>

    <div *ngFor="let event of data.dayEvents">
        <div class="border-cal tw-overflow-x-auto">
            <mat-divider></mat-divider>

            <div
                *ngIf="event.userName.length > 0"
                class="tw-text-center tw-font-bold"
            >
                {{ event.userName + " - " + event.title }}
            </div>

            <div
                *ngIf="event.userName.length <= 0"
                class="tw-text-center tw-font-bold"
            >
                {{ event.title }}
            </div>
        </div>

        <div *ngIf="event.timeOffType == undefined">
            {{ "- " + "Other" }}
        </div>

        <div *ngIf="event.timeOffType != undefined">
            {{ "- " + event.timeOffType }}
        </div>

        <div class="tw-mb-4">
            {{ "- " + (event.start | date: "MMM d, yyyy hh:mm a") }}
            to
            {{ event.end | date: "MMM d, yyyy hh:mm a" }}
        </div>

        <div class="tw-mb-2">
            {{ "- " + event.timeOffDescription }}
        </div>
    </div>
</div>
<app-dialog-exit (closeClick)="onClickClose()"></app-dialog-exit>
